// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__38hI1","main":"layout_main__b0Glz"};